import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroIntimacaoViaMalote extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com intimação via malote (apenas SIJ)';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        if (this.store.mapaProcessosPartes) {
            let partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];
            if (partesProcesso?.partes) {
                return partesProcesso.partes.findIndex((parte) => parte.intimarViaMaloteDigital) !== -1;
            }
        }
        return false;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    renderCarregando() {
        return this.renderCircularProgress('partes dos processos');
    }
}
